import React, { useEffect, useState } from "react";
import { Modal } from "src/components";
import ReporterManagerIcon from "src/components/Icons/reporterManagerIcon";
import { ReportManagerContainer, ReportWrapper } from "./style";
import { QuestionList } from "./components/QuestionList";
import { ReportConfiguration } from "./components/ReportConfiguration";
import { useReport } from "./context/ReportContext";
import { reportManagerService } from "./service";
import { QuestionAdapter } from "./adapter";
import { ModelToPayloadParser } from "./parser/modelToPayload";
import { useSelector } from "react-redux";
import { slicePageTitle } from "./utils/slicePageTitle";

export const ReportManager = ({
  // id da pesquisa
  surveyId,
  // id do cliente
  clientId,
  // boolean para exibição da modal
  showModal,
  // controla o fechamento da modal
  onClose,
  //
  onExport,
}) => {
  const {
    setQuestionList,
    setInitialSetup,
    initialSetup,
    setQuestionConfig,
    questionConfig,
    setReportConfig,
    reportConfig,
    questionState,
  } = useReport();
  const [loading, setLoading] = useState(false);
  const [originalReportData, setOriginalReportData] = useState(null);
  const [isProcessingReportGeneration, setIsProcessingReportGeneration] = useState(false);

  const reduxReportState = useSelector((state) => state.report.processedPayload)

  useEffect(() => {
    getReportData();
  }, [surveyId]);

  useEffect(() => {
    const isProcessingReportGeneration = reduxReportState.running;

    if (isProcessingReportGeneration) {
      setIsProcessingReportGeneration(true);
    } else if (!isProcessingReportGeneration && !reduxReportState.data) {
      setIsProcessingReportGeneration(false);
    }
  }, [reduxReportState]);

  // Recupera as configurações inicias do relatório e a lista de questões
  const getReportData = async () => {
    try {
      setLoading(true);
      const response = await reportManagerService.getReportData(
        surveyId,
        clientId
      );
      const adapted = QuestionAdapter.adaptQuestions([
        ...response.data.perguntas_relatorio,
      ]);
      setQuestionList(adapted);
      setInitialSetup({ ...response.data.pesquisa_relatorio });
      initializeQuestionConfig(adapted);
      setOriginalReportData({ ...response.data });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const initializeQuestionConfig = (questionList) => {
    questionList.forEach((q) => {
      setQuestionConfig((prevConfig) => ({
        ...prevConfig,
        [q.id]: {
          ...prevConfig[q.id],
          enunciado: q.enunciado,
          graficos: [...q.graficos],
        },
      }));
    });
  };

  /**
   * Verifica se os valores obrigatórios estão vazios
   * Se estiverem persiste os valores originais retornados pelo backend
   * a view não é atualizada, somente os dados persisitos no payload
   * @returns reportConfig com valores atualizados
   */
  const checkRequiredValues = () => {
    return {
      ...reportConfig,
      pageTitle: reportConfig.pageTitle?.length
        ? reportConfig.pageTitle
        : slicePageTitle(initialSetup?.titulo) || "",
      clientName: reportConfig.clientName?.length
        ? reportConfig.clientName
        : initialSetup?.cliente_nome || "",
      sample: reportConfig.sample?.length
        ? reportConfig.sample
        : initialSetup?.entrevistas || 0
    };
  }

  const handleReportExport = () => {
    const updatedReportConfig = checkRequiredValues();

    const newQuestionConfig = {};
    Object.keys(questionConfig)
      .filter((id) => questionState.some((q) => q.id == id && q.checked))
      .forEach(
        (questionId) =>
          (newQuestionConfig[questionId] = questionConfig[questionId])
      );

    const perguntasRelatorio = [...originalReportData.perguntas_relatorio];
    const currentSurveyId = originalReportData.pesquisa_relatorio.id;
     
    const reportPayload = ModelToPayloadParser.parse(
      currentSurveyId,
      newQuestionConfig,
      updatedReportConfig,
      perguntasRelatorio
    );

    if (typeof onExport === "function") {

      /**
       * Fecha a modal, provavelmente será removido posteriormente
       */
      onClose();

      /**
       * Delega a responsabildiade de exportação enviando o payload gerado
       */
      onExport(reportPayload);
    }

  };

  return !showModal ? null : (
    <ReportWrapper>
      <Modal
        showActions={!isProcessingReportGeneration}
        title={"Configurar relatório"}
        okBtnTitle={"EXPORTAR"}
        cancelBtnTitle={"VOLTAR"}
        isOpen={showModal}
        isLoading={loading}
        withLoadingSpinner={true}
        onCancel={onClose}
        onOk={handleReportExport}
        width={"1043px"}
        contentHeight={"632px"}
        borderTitle={"0 solid"}
        fontWeightTitle={"normal"}
        bodyDisplayType={"inline-block"}
        iconComponent={ReporterManagerIcon}
        btnPosition={"space-between"}
      >
        <ReportManagerContainer>
          <QuestionList />
          <ReportConfiguration />
        </ReportManagerContainer>
      </Modal>
    </ReportWrapper>
  );
};
